import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useHistory } from 'react-router-dom';
import { useGetSurveyResponseCount } from '../hooks';

type ResponseCountType = {
  surveyId: string;
  state: string;
  goToRoute: Function;
};

const ResponseCount = ({ surveyId, state, goToRoute }: ResponseCountType) => {
  const { data: responseCount, isFetching } =
    useGetSurveyResponseCount(surveyId);
  const history = useHistory();
  if (isFetching) return <Skeleton width={30} />;
  if (state === 'DRAFT')
    return (
      <span style={{ fontWeight: 600, color: 'var(--color-smoke-300' }}>-</span>
    );
  return (
    <a
      onClick={() =>
        goToRoute({
          path: `/response/${surveyId}`,
          history,
        })
      }
      className="link"
    >
      {responseCount?.count}
    </a>
  );
};

export default ResponseCount;
